import HistoryActions from "@redux/feature/EDIS/actions/History";
import HoldingAction from "@redux/feature/EDIS/actions/Holdings";
import ReqIdHistoryAction from "@redux/feature/EDIS/actions/ReqIdHistory";
export default (function () {
    return {
        edis: {
            holdingDetails: new HoldingAction(),
            historyDetails: new HistoryActions(),
            reqIdHistory: new ReqIdHistoryAction(),
        },
    };
});
